import React from "react";
import { Link } from "react-router-dom";
import logoImg from "../../assets/img/logo2.png";

function Footer() {
  return (
    <>
      <footer className="block p-10 py-5 border border-t-gray-300 xl:py-20 lg:pt-20 lg:pb-28 md:pt-14 md:pb-20 sm:pt-10 sm:pb-14">
        <div className="container px-4 mx-auto">
          <div className="flex flex-wrap items-center justify-center md:justify-between">
            <div className="flex flex-col w-full gap-5 px-4 md:w-4/12">
              <Link
                to="/"
                className="z-20 inline-block leading-relaxed whitespace-nowrap"
              >
                <img src={logoImg} alt="logo" className="h-10" />
              </Link>
              <div className="py-1 text-sm font-light text-center text-gray-400 md:text-left">
                Copyright © {new Date().getFullYear()}{" "}
                <a href="/" className="py-1 text-sm font-light text-gray-400">
                  코끼리협동조합
                </a>
              </div>
            </div>
            <div className="w-full px-4 md:w-8/12">
              <ul className="flex flex-wrap justify-center list-none md:justify-end">
                <li>
                  <a
                    href="/company"
                    className="block px-3 py-1 text-sm font-light text-gray-500 hover:text-gray-400"
                  >
                    회사 소개
                  </a>
                </li>
                <li>
                  <a
                    href="/works"
                    className="block px-3 py-1 text-sm font-light text-gray-500 hover:text-gray-400"
                  >
                    사업 소개
                  </a>
                </li>
                <li>
                  <a
                    href="/community"
                    className="block px-3 py-1 text-sm font-light text-gray-500 hover:text-gray-400"
                  >
                    커뮤니티
                  </a>
                </li>
                <li>
                  <a
                    href="/contact"
                    className="block px-3 py-1 text-sm font-light text-gray-500 hover:text-gray-400"
                  >
                    문의
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
